import { NavLink } from "react-router"

import { cn } from "@/lib/utils"
import { HEADER_NAV_ITEMS } from "./header.config"

type DesktopNavigationProps = {
  lightForeground: boolean
}

export const DesktopNavigation = ({ lightForeground }: DesktopNavigationProps) => (
  <nav
    aria-label="Điều hướng chính"
    className="hidden min-w-0 items-stretch self-stretch lg:flex"
  >
    {HEADER_NAV_ITEMS.map(({ label, to }) => (
      <NavLink
        key={to}
        to={to}
        end={to === "/"}
        className={({ isActive }) =>
          cn(
            "group relative flex items-center whitespace-nowrap px-1.5 text-center text-[10px] font-semibold uppercase tracking-[0.01em] transition-colors duration-200 xl:px-3 xl:text-xs xl:tracking-[0.015em]",
            lightForeground
              ? "text-white/85 hover:text-white focus-visible:text-white"
              : "text-[#4a4036]/80 hover:text-[#8b6748] focus-visible:text-[#8b6748]",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-current",
            isActive && (lightForeground ? "text-white" : "text-[#765638]"),
          )
        }
      >
        <span className="leading-4">{label}</span>
        <span
          aria-hidden="true"
          className="absolute inset-x-2 bottom-2 h-px origin-center scale-x-0 bg-current transition-transform duration-200 group-hover:scale-x-100 group-aria-[current=page]:scale-x-100"
        />
      </NavLink>
    ))}
  </nav>
)
